var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-button',{attrs:{"disabled":_vm.disabled,"loading":_vm.loading,"type":_vm.type,"icon":_vm.icon,"icon-only":_vm.iconOnly,"caption":_vm.innerCaption,"svg-icon":_vm.svgIcon,"data-cy":_vm.action},on:{"click":_vm.handleClick}})}
var staticRenderFns = []

export { render, staticRenderFns }